import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AspectRatioIcon(props: IconProps) {
    return <Icon {...props} iconKey={"aspect_ratio"}/>
}
